import { render, staticRenderFns } from "./RestoreAppretice.vue?vue&type=template&id=9e224630&"
import script from "./RestoreAppretice.vue?vue&type=script&lang=js&"
export * from "./RestoreAppretice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports